import React, { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconAlerta from "assets/images/icons/icono_alerta.ico";
import { useNavigate } from "react-router-dom";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function ClientesSiesa() {
  const [numeroEc2, setNumeroEc2] = useState(0);
  const [blocking, setBlocking] = React.useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "alerta-ec2-cpu" });
      if (data?.rows?.length > 0) {
        const obj = data.rows[0];
        console.log("obj....", obj["instance_id"]);
        setNumeroEc2(obj["instance_id"]);
      } else if (data?.error == 403) {
        // console.log("hola como estas!!!!!!!!!!!!!!!!");
        navigate("/login");
      }
      setBlocking(false);
    };
    catData();
  }, []);
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5} ml={0}>
        {blocking ? (
          <AppLoading titleCustom={"Alerta EC2"} />
        ) : (
          <ComplexStatisticsCard
            color="success"
            icon={<img src={iconAlerta} />}
            title="Alerta EC2"
            count={numeroEc2}
            percentage={{
              color: "success",
              amount: "2%",
              label: "Servidores alertados",
            }}
          />
        )}
      </MDBox>
    </Grid>
  );
}

export default ClientesSiesa;
